import React from 'react';

import * as styles from './styles.module.css';

class SimpleCheckbox extends React.PureComponent {
  render() {
    const flex = this.props.flex === 'column' ? styles.checkboxInputColumn : styles.checkboxInputRow;

    return (
      <div className={`form_checkbox_${this.props.index}_${this.props.idx}_${this.props.sectionId} ${flex}`}>
        <input
          type="checkbox"
          name={`checkboxOptionGroup_${this.props.index}_${this.props.sectionId}`}
          className={this.props.flex === 'column' ? styles.inputOptionColumn : styles.inputOptionRow}
          value={this.props.value}
          data-index={this.props.idx}
        />
        <span>{this.props.value}</span>
      </div>
    );
  }
}

export default SimpleCheckbox;
